var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"text-h5 text-center mt-5 mb-5"},[_vm._v(" "+_vm._s(_vm.$t('nodata.welcome'))+" ")]),_c('p',{staticClass:"text-subtitle-2 text-center pt-5 pb-5"},[_vm._v(_vm._s(_vm.$t('nodata.nofund')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }